import {WorkflowStep} from "../../enums/WorkflowStep";
import {WorkflowInstanceStepError} from "../../enums/WorkflowInstanceStepError";
import {WorkflowInstanceStepCommentModel} from "src/app/models/workflow-step/workflow-instance-step-comment.model";

export class WorkflowInstanceStepDto {

  id: number;
  error: WorkflowInstanceStepError;
  step: WorkflowStep;
  workflowNumber: string;
  isSkipped: boolean;
  createdBy: string;
  created: Date;
  comment: WorkflowInstanceStepCommentModel;

  static fromData(data: WorkflowInstanceStepDto): WorkflowInstanceStepDto {
    return Object.assign(new WorkflowInstanceStepDto(), data);
  }

}
